import type { HostedFields } from 'braintree-web';

import type { ActionContext } from 'js/lib/ActionContext';

import type { CreditCardData, PaymentWalletSettings } from 'bundles/account-settings/types/Payment';
import type { ThreeDSecureSettings } from 'bundles/account-settings/types/ThreeDSecureSettings';

export const updateCountry = (actionContext: ActionContext, { country }: { country: string }) => {
  actionContext.dispatch('UPDATE_COUNTRY', country);
};

export const updateZipcode = (actionContext: ActionContext, { zipcode }: { zipcode: string }) => {
  actionContext.dispatch('UPDATE_ZIPCODE', zipcode);
};

export const setCreditCardData = (actionContext: ActionContext, creditCardData: CreditCardData) => {
  actionContext.dispatch('SET_CREDIT_CARD_DATA', creditCardData);
};

export const setBraintreeClientToken = (
  actionContext: ActionContext,
  { braintreeClientToken }: { braintreeClientToken: string }
) => {
  actionContext.dispatch('SET_BRAINTREE_CLIENT_TOKEN', braintreeClientToken);
};

export const storeCreditCardToWallet = (actionContext: ActionContext, settings: PaymentWalletSettings) => {
  actionContext.dispatch('STORE_CREDIT_CARD_TO_WALLET', settings);
};

export const setActiveWalletId = (actionContext: ActionContext, walletId: { walletId: number }) => {
  actionContext.dispatch('SET_ACTIVE_WALLET_ID', walletId);
};

export const setThreeDSecureSettings = (actionContext: ActionContext, settings: ThreeDSecureSettings) => {
  actionContext.dispatch('SET_THREE_D_SECURE_SETTINGS', settings);
};

export const setBraintreeHostedFields = (
  actionContext: ActionContext,
  { braintreeHostedFields }: { braintreeHostedFields: HostedFields }
) => {
  actionContext.dispatch('SET_BRAINTREE_HOSTED_FIELDS', braintreeHostedFields);
};

export const clearBraintreeHostedFields = (actionContext: ActionContext) => {
  actionContext.dispatch('CLEAR_BRAINTREE_HOSTED_FIELDS');
};
